<template>
<section id="home-page-menu-media">
  <div class="container">
    <div class="row">
      <clearfix :biggest="true" :bootstrap="true"></clearfix>

      <div class="col-sm-4 animated xFadeInLeft" data-id="1">
        <div class="home-button home-media-button" @click="$router.push('/yt-gallery/')">
          <icon name="youtube" scale="6"></icon><br>&nbsp;<br>
          VIDEO
        </div>
      </div>

      <div class="col-sm-4 animated xFadeInRight" data-id="3">
        <div class="home-button home-media-button" @click="$router.push('/blog')">
          <icon name="rss" scale="6"></icon><br>&nbsp;<br>
          BLOG
        </div>
      </div>

      <div class="col-sm-4 animated xFadeInRight" data-id="3">
        <div class="home-button home-media-button">
          <icon name="camera-retro" scale="6"></icon><br>&nbsp;<br>
          FOTO
        </div>
      </div>
    </div>

    <clearfix :biggest="true"></clearfix>

  </div>
</section>
</template>

<script>
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import Clearfix from '@/components/utils/Clearfix'

  export default {
    components: { Clearfix, Icon }
  }
</script>

<style>
  #home-page-menu-media {
    background: url('../../assets/img/bg/arrows.png') 50% 0 fixed;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// MenuMedia.vue?ff788f00